import React, { createContext, useContext, useMemo } from 'react';

type SnapshotScope = {
  workspaceId: string | null;   // null until resolved
  periodKey: string;            // e.g. '2025-W37'
};

const Ctx = createContext<SnapshotScope | null>(null);

export const SnapshotScopeProvider: React.FC<{
  workspaceId: string | null;
  periodKey: string;
  children: React.ReactNode;
}> = ({ workspaceId, periodKey, children }) => {
  const value = useMemo(() => ({ workspaceId, periodKey }), [workspaceId, periodKey]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useSnapshotScope = () => {
  const v = useContext(Ctx);
  if (!v) throw new Error('useSnapshotScope must be used within SnapshotScopeProvider');
  return v;
};
